import { Component } from "react";
import { connect } from "react-redux";
import List from "@mui/material/List";
import HRFormListDetail from "./HRFormListDetail";
import {
    getEmployeesToManage,
    getFiltersInstance,
    getFormsAndInterviewsToManage,
} from "../../redux/humanResources/humanResourcesActions";
import FormsFilters from "./FormsFilters";

class FormsAsManagerTab extends Component {
    constructor(props) {
        super(props);

        props.getEmployeesToManage(this.props.activeUser);
        props.getFormsAndInterviewsToManage(
            this.props.activeUser,
            this.props.formsFilters[getFiltersInstance(false, true, false)]
        );
    }

    render() {
        let details = [];

        this.props.interviews.forEach((i) => {
            details.push(
                <HRFormListDetail
                    globalContainer={this.props.globalStore.container}
                    className="form-list-detail"
                    key={i.id}
                    interview={i}
                    formsToManageTab
                />
            );
        });

        return (
            <div className="container-with-footer">
                <FormsFilters interviews={this.props.interviews} formsToManageTab />
                <List className="row">{details.map((d) => d)}</List>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        interviews: state.forms.interviewsToManage,
        formsFilters: state.forms.formsFilters,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getFormsAndInterviewsToManage: (user, formsFilters) =>
            dispatch(getFormsAndInterviewsToManage(user, formsFilters)),
        getEmployeesToManage: (user) => dispatch(getEmployeesToManage(user)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormsAsManagerTab);
